
    <div class="modal-header">
      <h4 class="modal-title">Nota Premiada Bahia</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body" *ngIf="info">
      <h5>{{info}}</h5>
    </div>

    <div class="modal-body" *ngIf="listInfo">
      <h5 *ngFor="let info2 of listInfo; let i = index">{{info2}}</h5>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-bluelight" (click)="activeModal.dismiss('Cross click')">OK</button>
    </div>


// WEBPACK FOOTER //
// ./src/app/shared/modal/nbp-info.component.ts.NbpInfoComponent.html